import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Equipment from './components/Equipment';
import Pricing from './components/Pricing';
import Access from './components/Access';
import RulesSection from './components/RulesSection';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import FloatingReservation from './components/FloatingReservation';

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    const id = location.hash.replace('#', '');

    const scrollToSection = () => {
      const target = document.getElementById(id);

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    };

    const timer = setTimeout(scrollToSection, 100);

    return () => clearTimeout(timer);
  }, [location.hash]);

  return (
    <div className="bg-[#0a0e1a] min-h-screen">
      <Navbar />

      <main>
        <Hero />
        <Features />
        <Equipment />
        <Pricing />
        <Access />
        <RulesSection />
        <FAQ />
      </main>

      <Footer />
      <FloatingReservation />
    </div>
  );
}